/**
 * Список услуги в электронном виде
 */
import { Pagination } from '@n3/ng-api-common';
import { PublicDigitalServiceShort } from './publicDigitalServiceShort.model';
export class PublicDigitalServiceList extends Pagination {
    public _isEmpty: boolean; /*указывает на то пустой ли объект*/
    public items: PublicDigitalServiceShort[]; /**/

    constructor(json?: any) {
        if (json === void 0 || json === null) {
            json = {};
        }
        super(json);

        this.items = [];
        if (json.items) {
          for (const i in json.items) {
            if ( json.items.hasOwnProperty( i ) ) {
                this.items.push(new PublicDigitalServiceShort(json.items[i]));
            }
          }
        }
        this._isEmpty = this.isEmpty(this);
    }
}
